(() => {
  const OFFER_MARKER = 'vitala-collection-2-plus-1';
  const EBOOK_VARIANT_ID = 54911106941267;
  const KACHING_SHARED = {
    deal: 'Qzas',
    bar: '9bsN',
    v: '7d5d70d0-587f-442b-a691-b3812f433b2f'
  };
  let submitting = false;
  let normalizing = false;

  const routesRoot = () => window.Shopify?.routes?.root || '/';

  function readBundle(properties) {
    if (!properties || properties._vitala_collection_offer !== OFFER_MARKER) return null;
    try {
      return JSON.parse(properties.__kaching_bundles || '');
    } catch (error) {
      return null;
    }
  }

  function findOpenBundle(cart, mode) {
    const groups = new Map();

    for (const item of cart.items || []) {
      const properties = item.properties || {};
      if (properties._vitala_collection_mode !== mode || Number(item.variant_id) === EBOOK_VARIANT_ID) continue;
      const bundle = readBundle(properties);
      if (!bundle?.id) continue;

      const group = groups.get(bundle.id) || { id: bundle.id, quantity: 0 };
      group.quantity += Number(item.quantity) || 0;
      groups.set(bundle.id, group);
    }

    return [...groups.values()].find((group) => group.quantity > 0 && group.quantity < 3) || null;
  }

  async function addItems(items) {
    const response = await fetch(`${routesRoot()}cart/add.js?kaching_bundles=true`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items })
    });
    const payload = await response.json();
    if (!response.ok) throw new Error(payload.description || 'Could not add this item.');
    return payload;
  }

  async function normalizeMergedBundles() {
    if (submitting || normalizing) return;
    normalizing = true;

    try {
      const cartResponse = await fetch(`${routesRoot()}cart.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
      });
      const cart = await cartResponse.json();
      const groups = new Map();

      for (const item of cart.items || []) {
        if (Number(item.variant_id) === EBOOK_VARIANT_ID) continue;
        const bundle = readBundle(item.properties);
        if (!bundle?.id) continue;
        const group = groups.get(bundle.id) || { id: bundle.id, items: [], quantity: 0 };
        group.items.push(item);
        group.quantity += Number(item.quantity) || 0;
        groups.set(bundle.id, group);
      }

      const mergedGroup = [...groups.values()].find((group) =>
        group.quantity === 3 && group.items.some((item) => Number(item.quantity) > 1)
      );
      if (mergedGroup) {

      const orderedItems = [...mergedGroup.items].sort((left, right) =>
        Number(Boolean(readBundle(left.properties)?.bxgy)) - Number(Boolean(readBundle(right.properties)?.bxgy))
      );
      const unitSources = [];
      for (const item of orderedItems) {
        for (let index = 0; index < Number(item.quantity); index += 1) unitSources.push(item);
      }

      const updates = Object.fromEntries(mergedGroup.items.map((item) => [item.key, 0]));
      const removeResponse = await fetch(`${routesRoot()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates })
      });
      if (!removeResponse.ok) throw new Error('Could not prepare the 2 + 1 bundle.');

      const rebuiltItems = unitSources.map((source, index) => {
        const position = index + 1;
        const subscribed = Boolean(source.selling_plan_allocation?.selling_plan?.id);
        const bundle = { ...KACHING_SHARED, id: mergedGroup.id, main: true };
        const rebuilt = {
          id: Number(source.variant_id),
          quantity: 1,
          properties: {
            ...(source.properties || {}),
            __kaching_bundles: JSON.stringify(position === 3
              ? { ...bundle, bxgy: true }
              : { ...bundle, pp: Number(source.product_id) }),
            _vitala_collection_position: `${mergedGroup.id}-${position}`,
            _vitala_gift: ''
          }
        };
        if (subscribed) rebuilt.selling_plan = Number(source.selling_plan_allocation.selling_plan.id);
        return rebuilt;
      });

      await addItems(rebuiltItems);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

      const completedSubscriptionGroups = new Map(
        [...groups.values()]
          .filter((group) => group.quantity === 3 && group.items.every((item) =>
            item.properties?._vitala_collection_mode === 'subscription' &&
            Boolean(item.selling_plan_allocation?.selling_plan?.id)
          ))
          .map((group) => [group.id, group])
      );
      const validGiftGroups = new Set();
      const invalidGiftKeys = [];

      for (const item of cart.items || []) {
        if (Number(item.variant_id) !== EBOOK_VARIANT_ID) continue;
        const bundle = readBundle(item.properties);
        const isValidGift = bundle?.gift === '_abg' &&
          completedSubscriptionGroups.has(bundle.id) &&
          !validGiftGroups.has(bundle.id);

        if (isValidGift) validGiftGroups.add(bundle.id);
        else invalidGiftKeys.push(item.key);
      }

      if (invalidGiftKeys.length) {
        const removeGiftResponse = await fetch(`${routesRoot()}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ updates: Object.fromEntries(invalidGiftKeys.map((key) => [key, 0])) })
        });
        if (!removeGiftResponse.ok) throw new Error('Could not remove an ineligible e-book.');
      }

      const missingGiftItems = [...completedSubscriptionGroups.keys()]
        .filter((bundleId) => !validGiftGroups.has(bundleId))
        .map((bundleId) => ({
          id: EBOOK_VARIANT_ID,
          quantity: 1,
          properties: {
            _vitala_collection_offer: OFFER_MARKER,
            _vitala_collection_mode: 'subscription',
            __kaching_bundles: JSON.stringify({ ...KACHING_SHARED, id: bundleId, gift: '_abg' })
          }
        }));

      if (missingGiftItems.length) await addItems(missingGiftItems);
      if (invalidGiftKeys.length || missingGiftItems.length) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (error) {
      console.warn('[Vitala] Could not normalize the 2 + 1 bundle.', error);
    } finally {
      normalizing = false;
    }
  }

  async function addCollectionProduct(form) {
    const button = form.querySelector('[type="submit"]');
    const variantId = Number(form.querySelector('[name="id"]')?.value);
    const productId = Number(form.querySelector('[data-vitala-product-id]')?.value);
    const sellingPlanInput = form.querySelector('[name="selling_plan"]');
    const subscribed = Boolean(sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value);
    const mode = subscribed ? 'subscription' : 'onetime';

    if (!variantId || !productId) throw new Error('This product could not be added.');

    const cartResponse = await fetch(`${routesRoot()}cart.js`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    const cart = await cartResponse.json();
    const openBundle = findOpenBundle(cart, mode);
    const bundleId = openBundle?.id || `vitala-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const position = (openBundle?.quantity || 0) + 1;
    const sharedProperties = {
      _vitala_collection_offer: OFFER_MARKER,
      _vitala_collection_mode: mode
    };
    const bundle = { ...KACHING_SHARED, id: bundleId, main: true };
    const item = {
      id: variantId,
      quantity: 1,
      properties: {
        ...sharedProperties,
        _vitala_collection_position: `${bundleId}-${position}`,
        __kaching_bundles: JSON.stringify(position === 3
          ? { ...bundle, bxgy: true }
          : { ...bundle, pp: productId })
      }
    };

    if (subscribed) item.selling_plan = Number(sellingPlanInput.value);

    const items = [item];
    if (subscribed && position === 3) {
      items.unshift({
        id: EBOOK_VARIANT_ID,
        quantity: 1,
        properties: {
          ...sharedProperties,
          __kaching_bundles: JSON.stringify({ ...KACHING_SHARED, id: bundleId, gift: '_abg' })
        }
      });
    }

    try {
      await addItems(items);
    } catch (error) {
      const giftUnavailable = subscribed && position === 3 && /cannot find variant/i.test(error.message);
      if (!giftUnavailable) throw error;
      await addItems(items.filter((entry) => Number(entry.id) !== EBOOK_VARIANT_ID));
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.setTimeout(() => document.querySelector('cart-drawer')?.show(), 350);
    button?.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('form');
    if (!form?.querySelector('[data-vitala-product-id]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitting || !form.checkValidity()) return;

    const button = form.querySelector('[type="submit"]');
    submitting = true;
    button?.setAttribute('aria-busy', 'true');

    try {
      await addCollectionProduct(form);
    } catch (error) {
      button?.removeAttribute('aria-busy');
      form.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: error.message || 'Could not add this item.' }
      }));
    } finally {
      submitting = false;
    }
  }, true);

  document.addEventListener('cart:change', () => window.setTimeout(normalizeMergedBundles, 250));
  document.addEventListener('cart:refresh', () => window.setTimeout(normalizeMergedBundles, 250));
  window.setTimeout(normalizeMergedBundles, 0);
})();
